
import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
  GET_HISTORY_WEEKSTAAT: {
    url: "weekstaat?filter=historie",
    method: "get",
  },
  DOWNLOAD_REPORT: {
    url: (id) => `document/${id}/weekstaat`,
    method: "get",
  },
};


export const useHistoryWeekstaat = () =>
  useApiFetcherSWR(API_ENDPOINT.GET_HISTORY_WEEKSTAAT);

export const useDownloadWeekstaatReport = (id) =>
  useApiFetcherSWR(
     id
      ? {
        url: API_ENDPOINT.DOWNLOAD_REPORT.url(id),
        method: API_ENDPOINT.DOWNLOAD_REPORT.method,
      }
      : null
  );